export enum SUJETO_EXCLUIDO_TYPES {
  SUJETO_EXCLUIDO_FORMCLIENTE_HANDLE_CHANGE = 'SUJETO_EXCLUIDO_FORMCLIENTE_HANDLE_CHANGE',
  SUJETO_EXCLUIDO_FORMCLIENTE_SET_ERRORS = 'SUJETO_EXCLUIDO_FORMCLIENTE_SET_ERRORS',
  SUJETO_EXCLUIDO_FORMPRODUCTOS_HANDLE_CHANGE = 'SUJETO_EXCLUIDO_FORMPRODUCTOS_HANDLE_CHANGE',
  SUJETO_EXCLUIDO_FORMPRODUCTOS_SET_ERRORS = 'SUJETO_EXCLUIDO_FORMPRODUCTOS_SET_ERRORS',
  SUJETO_EXCLUIDO_FORMPRODUCTOS_HANDLE_CHANGE_EDIT = 'SUJETO_EXCLUIDO_FORMPRODUCTOS_HANDLE_CHANGE_EDIT',
  SUJETO_EXCLUIDO_FORMPRODUCTOS_SET_ERRORS_EDIT = 'SUJETO_EXCLUIDO_FORMPRODUCTOS_SET_ERRORS_EDIT',
  SUJETO_EXCLUIDO_FORMSUCURSAL_HANDLE_CHANGE = 'SUJETO_EXCLUIDO_FORMSUCURSAL_HANDLE_CHANGE',
  SUJETO_EXCLUIDO_FORMSUCURSAL_SET_ERRORS = 'SUJETO_EXCLUIDO_FORMSUCURSAL_SET_ERRORS',
  SUJETO_EXCLUIDO_FORMPRODUCTOS_CLEAR = 'SUJETO_EXCLUIDO_FORMPRODUCTOS_CLEAR',
  SUJETO_EXCLUIDO_ARRAYPRODUCTOS_ADD = 'SUJETO_EXCLUIDO_ARRAYPRODUCTOS_ADD',
  SUJETO_EXCLUIDO_ARRAYPRODUCTOS_EDIT = 'SUJETO_EXCLUIDO_ARRAYPRODUCTOS_EDIT',
  SUJETO_EXCLUIDO_ARRAYPRODUCTOS_SET_CALCULOS = 'SUJETO_EXCLUIDO_ARRAYPRODUCTOS_SET_CALCULOS',
  SUJETO_EXCLUIDO_ARRAYPRODUCTOS_CLEAR_ALL = 'SUJETO_EXCLUIDO_ARRAYPRODUCTOS_CLEAR_ALL',
  SUJETO_EXCLUIDO_ARRAYPRODUCTOS_SELECT_ONE = 'SUJETO_EXCLUIDO_ARRAYPRODUCTOS_SELECT_ONE',
  SUJETO_EXCLUIDO_ARRAYPRODUCTOS_DELETE_ONE = 'SUJETO_EXCLUIDO_ARRAYPRODUCTOS_DELETE_ONE',
  SUJETO_EXCLUIDO_CLEAR_ALL = 'SUJETO_EXCLUIDO_CLEAR_ALL',
  SUJETO_EXCLUIDO_SET_DATOS_EMISOR = 'SUJETO_EXCLUIDO_SET_DATOS_EMISOR',
  SUJETO_EXCLUIDO_SET_DATOS_FACTURA = 'SUJETO_EXCLUIDO_SET_DATOS_FACTURA',
  SUJETO_EXCLUIDO_FACTURA_EMITIDA = 'SUJETO_EXCLUIDO_FACTURA_EMITIDA',
  SUJETO_EXCLUIDO_OPCIONES_ACTIVA = 'SUJETO_EXCLUIDO_OPCIONES_ACTIVA',
  SUJETO_EXCLUIDO_SET_CATALOGO_SUCURSAL = 'SUJETO_EXCLUIDO_SET_CATALOGO_SUCURSAL',
  SUJETO_EXCLUIDO_SET_CATALOGO_SERIE = 'SUJETO_EXCLUIDO_SET_CATALOGO_SERIE',
  SUJETO_EXCLUIDO_SET_UUID = 'SUJETO_EXCLUIDO_SET_UUID',
  SUJETO_EXCLUIDO_ANULADO = 'SUJETO_EXCLUIDO_ANULADO',
  SUJETO_EXCLUIDO_DELETE_SERVICIOS = "SUJETO_EXCLUIDO_DELETE_SERVICIOS",

  // MODALS
  SUJETO_EXCLUIDO_MODALELIMINAR_OPEN = 'SUJETO_EXCLUIDO_MODALELIMINAR_OPEN',
  SUJETO_EXCLUIDO_MODALELIMINAR_CLOSE = 'SUJETO_EXCLUIDO_MODALELIMINAR_CLOSE',
  SUJETO_EXCLUIDO_MODALEDITAR_OPEN = 'SUJETO_EXCLUIDO_MODALEDITAR_OPEN',
  SUJETO_EXCLUIDO_MODALEDITAR_CLOSE = 'SUJETO_EXCLUIDO_MODALEDITAR_CLOSE',
  SUJETO_EXCLUIDO_MODALFACTURACION_OPEN = 'SUJETO_EXCLUIDO_MODALFACTURACION_OPEN',
  SUJETO_EXCLUIDO_MODALIMPRESION_OPEN = 'SUJETO_EXCLUIDO_MODALIMPRESION_OPEN',
  SUJETO_EXCLUIDO_MODALEMAIL_OPEN = 'SUJETO_EXCLUIDO_MODALEMAIL_OPEN',
  SUJETO_EXCLUIDO_MODALANULAR_OPEN = 'SUJETO_EXCLUIDO_MODALANULAR_OPEN',
  SUJETO_EXCLUIDO_FORMOBSERVACIONES_HANDLE_CHANGE = 'SUJETO_EXCLUIDO_FORMOBSERVACIONES_HANDLE_CHANGE',
}
